import { render, staticRenderFns } from "./RightBack.vue?vue&type=template&id=bb20668c&scoped=true&"
import script from "./RightBack.vue?vue&type=script&lang=js&"
export * from "./RightBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20668c",
  null
  
)

export default component.exports